export default "__VITE_ASSET__eebfe20e__"